(function () {
    'use strict';

    angular
        .module('app')
        .controller('EntityLinkedEditCtrl', EntityLinkedEditCtrl);

    EntityLinkedEditCtrl.$inject = ['entityField', 'templateField',  'EntitiesService', 'DialogService', 'DialogInstance'];

    /**
     * @ngdoc controller
     * @name EntityLinkedEditCtrl
     * @description Dialog for selecting an entity.
     */
    function EntityLinkedEditCtrl(entityField, templateField, EntitiesService, DialogService, DialogInstance) {
        /* jshint validthis:true */
        var vm = this;
        vm.ok = ok;
        vm.cancel = cancel;
        activate();

        function activate() {
            // The value is copied, we do not want to directly bind otherwise the source value will be changed even if the dialog is cancelled
            vm.entityField = angular.copy(entityField);

            loadAvailableEntities();
        }

        function loadAvailableEntities() {
            if (!angular.isUndefined(templateField) && templateField !== null) {
            EntitiesService.query({
                entityTemplateId: templateField.EntityTemplateId
            })
                .then(getEntitiesOk)
                .catch(getEntitiesError);
            } else {
                EntitiesService.query()
                    .then(getEntitiesOk)
                    .catch(getEntitiesError);
            }


            function getEntitiesOk(data) {
                vm.entities = data.Entities;
            }

            function getEntitiesError(response) {
                DialogService.error('Error fetching Entities', response);
            }
        }

        function ok() {
            DialogInstance.ok(vm.entityField);
        }

        function cancel() {
            DialogInstance.cancel();
        }
    }
})();
